import React from 'react';
import {calculateStrokeDashoffset} from "common/hook/calcul";
import {ItemSummaryTable} from "features/model/types/hr/getSummaryTable";
import {NavLink} from "react-router-dom";
import {RadialStatCol} from "components/pages/summary-table/table/table-items/radial-stat-col/RadialStatCol";

interface ITableItemsProps {
    item: ItemSummaryTable;
}

export const TableItems = ({ item }: ITableItemsProps) => {
    return (
        <div className="row">
            <div className="col student-col full-width-mobile">
                <span className="col-title">Студент</span>
                <div className="student-data-box">
                    <div className="avatar">
                        <img src={item.avatar} alt={item.fullName} />
                        <span className={`status-label ${item.onlineStatus}`} />
                    </div>
                    <div className="student-data">
                        <p className="name">
                            <NavLink to={`/groups/${item.groupId}/students-pages/${item.userId}`}>{item.fullName}</NavLink>{" "}
                        </p>
                        <p>{item.group}</p>
                    </div>
                </div>
            </div>
            <div className="col current-level-col small-w">
                <span className="col-title">Начальный уровень</span>
                <p>{item.beginLanguageLevel}</p>
            </div>
            <div className="col planned-level-col">
                <span className="col-title">Текущий уровень</span>
                <p>{item.currentLanguageLevel}</p>
            </div>
            <div className="col start-classes-col">
                <span className="col-title">Начало занятий</span>
                <p>{item.courseStart}</p>
            </div>
            <div className="col course-end-col">
                <span className="col-title">Прошедшие занятия</span>
                <p>{item.courseEnd}</p>
            </div>
            <RadialStatCol colTitle="Эффективность" percentValue={item.efficiency} />
            <RadialStatCol colTitle="Посещаемость" percentValue={item.attendance} />
        </div>
    );
};
